import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IValidationErrorResponse, NewsRssFeedType, ValidationModule, ValidationType } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { take } from 'rxjs/operators';
import { ValidatorService } from 'src/app/services/validator/validator.service';

@Component({
    selector: 'app-rss-validator-form',
    templateUrl: './rss-validator-form.component.html',
    styleUrls: ['./rss-validator-form.component.scss'],
})
export class RssValidatorFormComponent implements OnInit {
    form: FormGroup;
    validationModules = Object.values(ValidationModule);
    newsRssFeedTypes = Object.values(NewsRssFeedType);
    submitted = false;
    loading = false;
    results: IValidationErrorResponse[] = [];

    @Input() forceModule: ValidationModule | undefined;

    constructor(private fb: FormBuilder, private validatorService: ValidatorService, private toastService: ToastrService) {}

    ngOnInit(): void {
        this.form = this.fb.group(
            {
                url: new FormControl('', [Validators.required]),
                module: new FormControl('', [Validators.required]),
                newsRssFeedType: new FormControl('', {
                    validators: (control) => {
                        if (this.form?.get('module')?.value === ValidationModule.News) {
                            return Validators.required(control);
                        }
                        return null;
                    },
                }),
            },
            {
                updateOn: 'change',
            },
        );
    }

    validateRssUrl() {
        if (this.form.valid) {
            this.results = [];
            this.loading = true;
            this.validatorService
                .validateRssFromUrl(ValidationType.RSS, this.form.get('module').value, this.form.get('url').value, this.form.get('newsRssFeedType')?.value)
                .pipe(take(1))
                .subscribe(
                    (res) => {
                        this.results = res;
                        this.loading = false;
                        this.submitted = true;
                    },
                    (error) => {
                        this.results = [];
                        this.loading = false;
                        this.submitted = false;
                        this.toastService.error(error.error.message, `${error.error.statusCode}: ${error.error.error}`);
                    },
                );
        }
    }

    /**
     * Show RSS type input
     */
    get showRssTypeInput(): boolean {
        if (this.form.get('module').value === ValidationModule.News) {
            return true;
        }
        return false;
    }
}
